import { ButtonColor, TextButton, SubmitFile, ButtonVariant } from '../../../components';
import { FilePurpose } from '../../../types';

interface UploadMediaFilesProps {
  onBack: () => void;
}

const UploadMediaFiles = ({ onBack }: UploadMediaFilesProps) => {
  return (
    <div className="flex flex-col gap-4">
      <SubmitFile
        purpose={FilePurpose.CALL_CREATION}
        successToastData={{
          title: 'Calls processing...',
          message: 'Files submitted successfully',
        }}
      />
      <div className="flex justify-end">
        <TextButton variant={ButtonVariant.SOFT} color={ButtonColor.NEUTRAL} text="Back" onClick={onBack} />
      </div>
    </div>
  );
};

export default UploadMediaFiles;
